import { render, staticRenderFns } from "./RepaymentSchedule.vue?vue&type=template&id=32213259&scoped=true&"
import script from "./RepaymentSchedule.vue?vue&type=script&lang=js&"
export * from "./RepaymentSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RepaymentSchedule.vue?vue&type=style&index=0&id=32213259&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32213259",
  null
  
)

export default component.exports